import instObj from '@/backend/axios-instances'

const resource = "/ticketing/companies"
const instance = instObj.baseInstance

export default {
  get(parameters) {
    return instance.get(resource, { params: parameters });
  },
  post(data) {
    return instance.post(resource, data);
  }
}
